module.exports = __webpack_public_path__ + "static/media/buscar-logo-square.f66dbaca.png";